<ng-container *ngIf="items$ | async as items">
  <div *ngIf="items.length" class="cart-modal">
    <div class="row">
      <div class="col-12">
        <div class="bg-secondary text-center text-white items-count mb-3">
          <div class="row">
            <div class="col-10" *ngSubscribe="totalItems$ as totalItems">
              <h4 class="font-size-14 m-0 py-2 ps-5">
                <span>{{ totalItems }} ITEM<span *ngIf="totalItems > 1">S</span> IN BASKET</span>
              </h4>
            </div>
            <div class="col-2">
              <button
                class="btn m-0 p-0 h-100"
                (click)="closeCartModal()"
                attr.aria-label="{{ 'cart.close.modal.screenreader' | translate }}"
              >
                <span class="icon material-icons text-white align-middle">close</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <fgbcl-cart-item></fgbcl-cart-item>
      <div class="row mb-3">
        <div class="col-6 text-start ps-4 font-size-14">
          <span class="fw-bold">{{ 'cart.modal.points' | translate }} </span>
          {{ basketPointsTotal$ | async | number }}
        </div>
        <div class="col-6 text-end pe-4">
          <a
            [routerLink]="['/checkout']"
            routerLinkActive="router-link-active"
            class="px-0 py-0 rounded"
            (click)="closeCartModal()"
          >
            <button class="btn btn-success fw-bold w-100 dropdown-checkout-btn font-size-14 text-on-success">
              {{ 'cart.modal.checkout' | translate }}
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!items.length">
    <div class="bg-secondary text-center text-white items-count mb-3 justify-content-between">
      <div class="row">
        <div class="col-10">
          <h4 class="font-size-14 m-0 py-2 ps-5">
            0 <span>{{ 'cart.modal.items.basket' | translate }}</span>
          </h4>
        </div>
        <div class="col-2">
          <button
            class="btn m-0 p-0 h-100"
            (click)="closeCartModal()"
            attr.aria-label="{{ 'cart.close.modal.screenreader' | translate }}"
          >
            <span class="icon material-icons text-white align-middle">close</span>
          </button>
        </div>
      </div>
    </div>
    <p class="mb-3 text-center font-size-14">{{ 'cart.modal.empty.basket' | translate }}</p>
  </div>
</ng-container>
